
import React from "react";
import {IhioReferencePrescriptionType} from "../../../../types/ihioPrescription";

type OrderPartnerInfoProps = {
    orderedPrescriptionData: IhioReferencePrescriptionType | null;
}

const OrderPartnerInfo = ({
    orderedPrescriptionData,
}: OrderPartnerInfoProps) => {

    return(
        <>
            <div className={'w-100 rounded rounded-4 border border-primary bg-white mt-8 py-3 px-4'}>
                <div className="row row-cols-md-3 row-cols-2 mt-3">
                    <div className={'d-flex align-items-center mb-3'}>
                        <span className={'text-gray-600 ms-3'}>
                            نام شریک کاری:
                        </span>
                        <span className={'text-gray-900'}>
                            {orderedPrescriptionData?.partnerName}
                        </span>
                    </div>
                    <div className={'d-flex align-items-center mb-3'}>
                        <span className={'text-gray-600 ms-3'}>
                            نام همکار:
                        </span>
                        <span className={'text-gray-900'}>
                            {orderedPrescriptionData?.providerName}
                        </span>
                    </div>
                    <div className={'d-flex align-items-center mb-3'}>
                        <span className={'text-gray-600 ms-3'}>
                            تاریخ تجویز:
                        </span>
                        <span className={'text-gray-900'}>
                            {orderedPrescriptionData?.creationDate}
                        </span>
                    </div>
                </div>

            </div>
        </>
    )
}


export default OrderPartnerInfo;